/**
 * Initials for the sender avatar — two letters from the display name, else the
 * first two of the email local-part. Shared by the task pane (App.tsx) and the
 * Office Dialog composer (dialog.tsx) so both render the same avatar.
 */
export function senderInitials(name: string, email: string): string {
  const source = (name.trim() || email.trim()).replace(/@.*$/, '');
  if (!source) return '?';
  const parts = source.split(/[\s._-]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return source.slice(0, 2).toUpperCase();
}
